/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetStudentHighlightsForCourseR200ResponseLeastAccurateAccuracyEnum = {
    VeryPoor: 'very-poor',
    Poor: 'poor',
    Okay: 'okay',
    Good: 'good',
    Great: 'great'
};
/**
 * Check if a given object implements the GetStudentHighlightsForCourseR200ResponseLeastAccurate interface.
 */
export function instanceOfGetStudentHighlightsForCourseR200ResponseLeastAccurate(value) {
    if (!('accuracy' in value) || value['accuracy'] === undefined)
        return false;
    if (!('studentId' in value) || value['studentId'] === undefined)
        return false;
    return true;
}
export function GetStudentHighlightsForCourseR200ResponseLeastAccurateFromJSON(json) {
    return GetStudentHighlightsForCourseR200ResponseLeastAccurateFromJSONTyped(json, false);
}
export function GetStudentHighlightsForCourseR200ResponseLeastAccurateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accuracy': json['accuracy'],
        'studentId': json['studentId'],
    };
}
export function GetStudentHighlightsForCourseR200ResponseLeastAccurateToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'accuracy': value['accuracy'],
        'studentId': value['studentId'],
    };
}
